<template>
  <div class="card agent-photo-card mb-4">
    <div class="card-body">
      <a :href="editAgentUrl" class="h6 font-weight-bold media text-decoration-none mb-3">
        <span class="media-left mr-2">
          <i class="fa fa-group"></i>
        </span>
        <span class="media-body">
          <div>{{ agent.name }}</div>
          <small>{{ agent.office.city }}</small>
        </span>
      </a>
      <div class="landscape-photo-container">
        <dropzone
          variant="custom"
          type="image"
          @uploaded="onUploadedLandscapeImage(arguments[0])">
          <div
            class="landscape-photo"
            :style="agentLandscapePhoto ? 'background-image:url(' + agentLandscapePhoto  + ')' : ''"></div>
        </dropzone>
      </div>
      <div class="portrait-photo-container">
        <dropzone
          variant="custom"
          type="image"
          @uploaded="onUploadedPortraitImage(arguments[0])">
          <div class="portrait-photo">
            <span
              class="profile-img md top"
              :style="agentPortraitPhoto ? 'background-image:url(' + agentPortraitPhoto  + ')' : ''">
              <span class="profile-img-body"></span>
            </span>
          </div>
        </dropzone>
      </div>
      <hr>
      <small class="media">
        <span class="media-body">
          Portrait
        </span>
        <span class="media-right">
          {{ portraitSize }}
        </span>
      </small>
      <small class="media">
        <span class="media-body">
          Landscape
        </span>
        <span class="media-right">
          {{ landscapeSize }}
        </span>
      </small>
      <hr>
      <small class="media text-muted">
        <span class="media-body">
          <i class="fa fa-info-circle mr-1"></i>
          {{ agent.mls_connection }}
        </span>
        <span class="media-right">
          #{{ agent.mls_id }}
        </span>
      </small>
    </div>
    <a :href="editUserUrl" target="_blank" class="card-footer text-body text-decoration-none">
      <small :class="{ 'media': true, 'text-muted': !agentUser }">
        <span class="media-left mr-3">
          <i class="fa fa-user"></i>
        </span>
        <span class="media-body">
          {{ agentUserName }}
        </span>
        <span class="media-right">
          <span class="profile-img tiny" :style="agentUserImage ? 'background-image:url(' + agentUserImage  + ')' : ''">
            <span class="profile-img-body"></span>
          </span>
        </span>
      </small>
    </a>
  </div>
</template>

<style lang="scss">
  .landscape-photo-container {
    position: relative;
    .landscape-photo {
      height: 80px;
      background-color: #ccc;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
    }
  }

  .portrait-photo-container {
    position: relative;
    margin-top: -50px;
    transition: margin-top 0.3s;
  }

  .portrait-photo {
    .profile-img {
      -webkit-box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.36);
      -moz-box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.36);
      box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.36);
    }
  }

  .agent-photo-card {
    &:hover {
      .portrait-photo-container {
        margin-top: 30px;
      }
    }
  }
</style>

<script>
import { get } from 'lodash'
import Dropzone from '@/components/Dropzone'
import { saveAgentPortraitImage, saveAgentLandscapeImage } from '@/api'

export default {
  components: {
    Dropzone
  },
  props: {
    agent: {
      required: true,
      type: Object
    },
    editAgentUrl: String,
    editUserUrl: String
  },
  data () {
    return {
      agentData: this.agent
    }
  },
  computed: {
    agentUser () {
      return get(this.agentData, 'user')
    },
    agentUserName () {
      return get(this.agentData, 'user.name') || 'Unclaimed'
    },
    agentPortraitPhoto () {
      return get(this.agentData, 'portrait_photo_url')
    },
    agentLandscapePhoto () {
      return get(this.agentData, 'landscape_photo_url')
    },
    agentUserImage () {
      return get(this.agentData, 'user.image') || ''
    },
    portraitSize () {
      if (this.agent.portrait_photo) {
        return `${this.agent.portrait_photo.image_resolution.width}x${this.agent.portrait_photo.image_resolution.height}`
      } else {
        return '—'
      }
    },
    landscapeSize () {
      if (this.agent.landscape_photo) {
        return `${this.agent.landscape_photo.image_resolution.width}x${this.agent.landscape_photo.image_resolution.height}`
      } else {
        return '—'
      }
    }
  },
  methods: {
    onUploadedPortraitImage (response) {
      saveAgentPortraitImage(this.agent.id, response.id)
        .then((response) => {
          this.agentData = response.data
        })
    },
    onUploadedLandscapeImage (response) {
      saveAgentLandscapeImage(this.agent.id, response.id)
        .then((response) => {
          this.agentData = response.data
        })
    }
  }
}
</script>
